import React from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';
import './BackButton.scss';

interface BackButtonProps {
  onClick: () => void;
  className?: string;
}

export const BackButton: React.FC<BackButtonProps> = ({ onClick, className = '' }) => {
  return (
    <div 
      className={`back-button ${className}`}
      onClick={onClick}
    >
      <ArrowLeftOutlined />
    </div>
  );
};
